<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '12px' }">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="20">
            <h6>Service History</h6>
            <p>
              please click the create ticket button to let us know how we can
              help you.
            </p>
          </a-col>
          <a-col :span="24" :md="4" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
            ">
            <a-button @click="toCreateTicket" block type="primary">
              Create Ticket
            </a-button>
          </a-col>
        </a-row>
      </template>
      <a-row :gutter="[24, 24]">
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <!-- filter -->
          <div
            class="text-center mb-15"
            style="display: flex; justify-content: center; align-items: center; margin-bottom: 15px;"
          >
            <a-radio-group v-model="filterVal" :value="filterVal" @change="handleChange">
              <a-radio-button v-for="(btnList, index) in listFilter" :key="'btn' + index" :value="btnList">
                {{ btnList }}
              </a-radio-button>
            </a-radio-group>
          </div>
          <!-- filter -->
          <div v-if="listTicket.length != 0">
            <div v-for="(query, line) in listTicket" :key="'Ticket' + line">
              <a-card :bordered="false" class="mt-10 card-billing-info">
                <div class="col-info">
                  <a-descriptions :column="1">
                    <template slot="title">
                      <p class="mb-0">No : {{ query.id }}</p>
                      <small>Type :
                        <a-tag>{{
                          query.ticket_type_detail.toUpperCase()
                          }}</a-tag></small>
                    </template>
                    <a-descriptions-item class="mt-5" label="Tag">

                      <span v-for="(listTag, index) in query.tag_lable" :key="'listTag' + index">
                        <a-tag :color="listTag.lable_detail.color">
                          {{
                            listTag.lable_detail.detail
                          }}
                        </a-tag>
                      </span>
                    </a-descriptions-item>
                    <a-descriptions-item label="Query">
                      {{ query.topic }}
                    </a-descriptions-item>
                    <a-descriptions-item label="Status">
                      <a-tag :color="query.status === 'success'
                          ? 'green'
                          : query.status === 'accept'
                            ? 'purple'
                            : query.status === 'wait'
                              ? 'orange'
                              : ''
                        ">
                        {{
                          query.status === "wait"
                            ? "open"
                            : query.status === "accept"
                              ? "in progress"
                              : query.status === "success"
                                ? "success"
                                : query.status === "cancel"
                                  ? "canceled"
                                  : ""
                        }}
                      </a-tag>
                    </a-descriptions-item>
                  </a-descriptions>
                </div>
                <div class="col-action">
                  <a-button v-if="query.status === 'wait'" type="link" size="small" @click="deleteRequest(query)">
                    <span class="text-danger"><a-icon :style="{ fontSize: '18px' }" type="delete" /></span>
                  </a-button>
                  <a-button type="link" size="small" @click="openDetail(query)">
                    <span class="text-dark"><a-icon :style="{ fontSize: '18px' }"
                        :type="viewId == query.id ? 'folder-open' : 'folder'" /></span>
                  </a-button>
                </div>
              </a-card>
            </div>
          </div>
          <div v-else>
            <a-empty><span slot="description">
                No Ticket .
                <a @click="toCreateTicket">please click the create ticket button</a>
              </span></a-empty>
          </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <Detailservice :viewDetail="viewDetail" :dataContent="dataContent" :dataMsg="dataMsg"
            @updateComment="updateComment" @updateTicket="updateTicket" @closeDetail="closeDetail" />
        </a-col>
      </a-row>
    </a-card>
    <!-- dialog -->
    <a-modal v-model="dialogDelete" title="Confirm Delete !" ok-text="Delete" ok-type="danger" cancel-text="Close"
      @ok="submitDelete(objData.id)">
      <p class="mb-10"><strong>Are you sure delete this ticket ?</strong></p>
      <div v-if="dialogDelete">

        <p class="mt-20 mb-5"><strong>Ticket</strong> : {{ objData.id }}</p>
        <p class="mt-0 mb-5">
          <strong>Type</strong> : {{ objData.ticket_type_detail }}
        </p>
        <p class="mt-0 mb-5"><strong>Subject</strong> : {{ objData.topic }}</p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Detailservice from "./detailservice.vue";
export default {
  components: {
    Detailservice,
  },
  data() {
    return {
      viewId: "",
      listTicket: [],
      dataContent: [],
      viewDetail: false,
      dataMsg: [],
      // modal-delete
      dialogDelete: false,
      objData: {},
      // group filter status
      FbtnSearch: "all",
      filterVal: "all",
      listFilter: ["all", "wait", "accept", "success"],
    };
  },
  mounted() {
    this.getListServeice();
  },
  watch: {
    filterVal(val) {
      this.viewId = ""
      this.viewDetail = false
    }
  },
  methods: {
    // filter
    handleChange(e) {
      this.filterVal = e.target.value;
      this.FbtnSearch = e.target.value;
      this.getListServeice()
    },
    // filter
    toCreateTicket() {
      this.$router
        .push({
          path: "/service/form",
        })
        .catch((err) => { });
    },
    async getListServeice() {
      this.viewId = ""
      this.viewDetail = false
      try {
        const res = await this.$http.get("/ticket/me/");
        if (res.status === 200) {
          if (this.filterVal === "all") {
            this.listTicket = res.data.map((item) => ({ ...item }));
          } else {
            this.listTicket = res.data
              .filter((Job) => {
                return Job.status === this.filterVal;
              })
              .map((item) => ({ ...item }));
          }
          this.listTicket.sort((a, b) => {
            return b.id - a.id;
          });
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.listTicket = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /ticket/me/`,
        });
      }
    },
    async openDetail(data) {
      try {
        const resMsg = await this.$http.get(`/ticket/msg/pull/${data.id}/`);
        if (resMsg.status == 200) {
          this.dataMsg = resMsg.data.map((item) => ({ ...item }));
          this.viewId = data.id;
          this.dataContent = [];
          this.dataContent.push(data);
          this.viewDetail = true;
        } else {
          const error = new Error('Request Failed');
          error.resMsg = resMsg;
          error.response = resMsg;
          throw error;
        }
      } catch (error) {
        this.dataMsg = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /ticket/msg/pull/${data.id}/`,
        });
      }
    },
    // comment
    updateComment(...args) {
      this.dataMsg.push(args[0]);
    },
    // close-ticket
    closeDetail(updatedData) {
      if (updatedData && updatedData.id) {
        const index = this.listTicket.findIndex((list) => list.id === updatedData.id);
        if (index !== -1) {
          this.listTicket.splice(index, 1, updatedData);
        }
      }
      this.viewId = "";
      this.viewDetail = false;
      this.dataContent = [];
      this.dataMsg = [];
    },
    updateTicket(...args) {
      const arrUp = [];
      const updatedTicket = args[0];
      const options = args[1] || {};
      const index = this.listTicket.findIndex((list) => list.id === (updatedTicket && updatedTicket.id));
      arrUp.push(updatedTicket);
      if (index !== -1) {
        this.listTicket.splice(index, 1, arrUp[0]);
      }
      if (options.closeDetail) {
        this.closeDetail(updatedTicket);
      } else {
        this.openDetail(arrUp[0]);
      }
    },
    // delete
    closeDialog() {
      this.dialogDelete = false;
      this.objData = {};
    },
    deleteRequest(dataObj) {
      this.objData = Object.assign({}, dataObj);
      this.dialogDelete = true;
    },
    async submitDelete(Jobid) {
      try {
        const response = await this.$http.delete(`/ticket/remove/${Jobid}/`, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status === 200) {
          this.getListServeice();
          this.closeDialog();
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /ticket/remove/${Jobid}/`,
        });
      }
    },
  },
};
</script>